import React from "react";
import Head from "../Global/Head";
import Header from "../Global/Header";
import Footer from "../shared/footer/Footer";
import {
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandWhatsapp,
  IconMail,
} from "@tabler/icons-react";

const ContactUs = () => {
  return (
    <div>
      <Head />
      <Header />
      <section className="text-gray-600 body-font px-[24px] relative md:flex">
        <div className="hidden md:flex lg:w-2/3 md:w-1/2 bg-gray-300 rounded-lg overflow-hidden sm:mr-10 p-10  items-end justify-start relative">
          <iframe
            width="100%"
            height="100%"
            className="absolute inset-0"
            frameBorder={0}
            title="map"
            marginHeight={0}
            marginWidth={0}
            scrolling="no"
            src="https://maps.google.com/maps?width=100%&height=600&hl=en&q=12.952940635954638,77.62428009634424&ie=UTF8&t=&z=14&iwloc=B&output=embed"
            style={{ filter: "grayscale(0.05) contrast(1.2) opacity(0.4)" }}
          />

          <div className="bg-white relative flex flex-wrap py-6 rounded shadow-md">
            {/* <div className="lg:w-1/2 px-6">
              <h2 className="title-font font-semibold text-gray-900 tracking-widest text-xs">
                ADDRESS
              </h2>
              <p className="mt-1">
                Adya 13 & 14, No 4, 6 Cross, 9th Main, Srinivagilu Main Road
                Near Koramangala bus depot, Koramangala Bangalore, Karnataka
                560047 India
              </p>
            </div> */}
            <div className="lg:w-1/2 px-6 mt-4 lg:mt-0">
              <h2 className="title-font font-semibold text-gray-900 tracking-widest text-xs">
                EMAIL
              </h2>
              <a className="text-blue-500 leading-relaxed">
                support@hightable.ai
              </a>
              <h2 className="title-font font-semibold text-gray-900 tracking-widest text-xs mt-4">
                High Table Network Private Limited
              </h2>
            </div>
          </div>
        </div>
        <div className="lg:w-1/3 md:w-1/2 bg-white flex flex-col md:ml-auto w-full  md:mt-0">
          <h2 className="text-gray-900 text-3xl mb-1 font-semibold title-font">
            Contact Us
          </h2>
          <p className="leading-relaxed mb-5 text-gray-600 hidden md:inline ">
            If you have questions or comments about this notice, you may email
            us at support@hightable.ai or contact us by post us
          </p>
          <br/>
          {/* <p className="leading-relaxed mb-5 text-gray-600 text-sm md:hidden">
            Adya 13 & 14, No 4, 6 Cross, 9th Main, Srinivagilu Main Road Near
            Koramangala bus depot, Koramangala Bangalore, Karnataka 560047 India
          </p> */}
          <div class="grid grid-cols-2 gap-4 z-20 relative ">
            <div class="flex flex-col items-center justify-center rounded-lg w-full h-44 p-4 text-center bg-white shadow-[0_2px_10px_-3px_rgba(6,81,237,0.3)]">
              <IconBrandWhatsapp className="w-6 h-6 text-[#c9a356]" />
              <h4 class="text-gray-800 text-sm font-bold mt-4">Whatsapp</h4>
              <p class="text-xs text-gray-600 mt-1"> +91 90364 33636</p>
            </div>
            <div class="flex flex-col items-center justify-center rounded-lg w-full h-44 p-4 text-center bg-white shadow-[0_2px_10px_-3px_rgba(6,81,237,0.3)]">
              <IconMail className="w-6 h-6 text-[#c9a356]" />
              <h4 class="text-gray-800 text-sm font-bold mt-4">Mail us</h4>
              <p class="text-xs text-gray-600 mt-1">support@hightable.ai</p>
            </div>
            <div class="flex flex-col items-center justify-center rounded-lg w-full h-44 p-4 text-center bg-white shadow-[0_2px_10px_-3px_rgba(6,81,237,0.3)]">
              <IconBrandFacebook className="w-6 h-6 text-[#c9a356]" />
              <h4 class="text-gray-800 text-sm font-bold mt-4">
                Facebook page
              </h4>
              <a
                href="https://www.facebook.com/people/HighTable/61570316743206/"
                class="text-xs text-gray-600 mt-1"
              >
                HighTable
              </a>
            </div>
            <div class="flex flex-col items-center justify-center rounded-lg w-full h-44 p-4 text-center bg-white shadow-[0_2px_10px_-3px_rgba(6,81,237,0.3)]">
              <IconBrandInstagram className="w-6 h-6 text-[#c9a356]" />
              <h4 class="text-gray-800 text-sm font-bold mt-4">
                Instagram Handle
              </h4>
              <a
                href="https://www.instagram.com/hightable.irl/"
                class="text-xs text-gray-600 mt-1"
              >
                @hightable.irl
              </a>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default ContactUs;
